import { ACCOUNT_ID_FOR_EXTENDED_TESTS } from 'environment';

angular
.module('app.views')
.controller('NewExtendedTestController', function($scope, $modalInstance, $q, Boxcaster, Broadcast){
  // Valid extended test durations and a default duration.
  $scope.DURATIONS = [
    {label: "1 hour",  value: 1 * 60 * 60 * 1000},
    {label: "2 hours", value: 2 * 60 * 60 * 1000},
    {label: "3 hours", value: 3 * 60 * 60 * 1000},
    {label: "4 hours", value: 4 * 60 * 60 * 1000},
    {label: "5 hours", value: 5 * 60 * 60 * 1000},
    {label: "6 hours", value: 6 * 60 * 60 * 1000},
    {label: "7 hours", value: 7 * 60 * 60 * 1000},
    {label: "8 hours", value: 8 * 60 * 60 * 1000},
  ];
  $scope.DEFAULT_DURATION = 6 * 60 * 60 * 1000;

  // Valid extended test video bitrates and a default video bitrate.
  $scope.VIDEO_BITRATES = [
    {label: "auto", value: "default"},
    {label: "300 kbps", value: 300000},
    {label: "500 kbps", value: 500000},
    {label: "700 kbps", value: 700000},
    {label: "900 kbps", value: 900000},
    {label: "1.2 Mbps", value: 1200000},
    {label: "1.5 Mbps", value: 1500000},
    {label: "2.0 Mbps", value: 2000000},
    {label: "2.5 Mbps", value: 2500000},
    {label: "3.0 Mbps", value: 3000000},
  ];
  $scope.DEFAULT_VIDEO_BITRATE = "default";

  // Valid extended test audio bitrates and a default audio bitrate.
  $scope.AUDIO_BITRATES = [
    {label: "auto", value: "default"},
    {label: "48 kbps",  value: 48000},
    {label: "64 kbps",  value: 64000},
    {label: "96 kbps",  value: 96000},
    {label: "128 kbps", value: 128000},
  ];
  $scope.DEFAULT_AUDIO_BITRATE = "default";

  // Offset from "now" for the start time (15 minutes minimum).
  //
  // The API's forecaster looks at the schedule of upcoming broadcasts to know how many servers to
  // keep up, plus some reserve. During off-peak hours when nothing is broadcasting, only the
  // reserve is kept alive, and starting a large number of extended tests at once will completely
  // consume the reserve servers and delay any "real" broadcasts from starting. Since it takes 10-12
  // minutes to bring up new servers, scheduling extended tests 15 minutes in advance gives the API
  // forecaster enough advance warning to bring up the servers needed for these broadcasts, as well
  // as maintain the reserve in case any new (real) broadcasts are added on the fly.
  $scope.START_OFFSETS = [
    {label: "15 minutes", value: 15 * 60 * 1000},
    {label: "1 hour",  value: 1 * 60 * 60 * 1000},
    {label: "2 hours", value: 2 * 60 * 60 * 1000},
    {label: "3 hours", value: 3 * 60 * 60 * 1000},
    {label: "4 hours", value: 4 * 60 * 60 * 1000},
    {label: "5 hours", value: 5 * 60 * 60 * 1000},
    {label: "6 hours", value: 6 * 60 * 60 * 1000},
    {label: "7 hours", value: 7 * 60 * 60 * 1000},
    {label: "8 hours", value: 8 * 60 * 60 * 1000},
  ]
  $scope.DEFAULT_START_OFFSET = 15 * 60 * 1000;

  $scope.isCreating = false;
  $scope.duration = $scope.DEFAULT_DURATION;
  $scope.target_video_bitrate = $scope.DEFAULT_VIDEO_BITRATE;
  $scope.target_audio_bitrate = $scope.DEFAULT_AUDIO_BITRATE;
  $scope.start_offset = $scope.DEFAULT_START_OFFSET;
  $scope.boxcasters = [];

  // Load BoxCasters based on a query from the input control.
  $scope.loadBoxcasters = query=> Boxcaster.query({q: `+account_id:${ACCOUNT_ID_FOR_EXTENDED_TESTS} id:*${query}*`, s: 'id'}).$promise;

  // Called when the user clicks Create.
  $scope.ok = function() {
    const start = new Date(Date.now() + parseInt($scope.start_offset));
    const stop = new Date(start.getTime() + parseInt($scope.duration));
    $scope.isCreating = true;

    // Use $q.all to collect promises for each of the new broadcasts -- one for each BoxCaster.
    return $q.all(
      _.map($scope.boxcasters, b=>
        Broadcast.create({
          account_id: ACCOUNT_ID_FOR_EXTENDED_TESTS,
          name: `Extended ${b.id.substr(-6)}`,
          description: `Extended test of ${b.id} from ${start.toISOString()} to ${stop.toISOString()} using target bitrates ${$scope.target_video_bitrate} video / ${$scope.target_audio_bitrate} audio.`,
          starts_at: start.toISOString(),
          stops_at: stop.toISOString(),
          target_video_bitrate: $scope.target_video_bitrate,
          target_audio_bitrate: $scope.target_audio_bitrate,
          boxcaster_id: b.id,
          is_private: true
        })
      )
    ).then( ()=> $modalInstance.close(), ()=> $modalInstance.dismiss('error'));
  };

  // Called when the user clicks Cancel
  return $scope.cancel = () => $modalInstance.dismiss('cancel');
});


// WEBPACK FOOTER //
// ./views/extended_tests/new_extended_test_controller.js